var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component, createRef } from "react";
import { Container } from "./styled/menu-button";
var MenuButton = /** @class */ (function (_super) {
    __extends(MenuButton, _super);
    function MenuButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = createRef();
        _this.handleOnKeyDown = function (e) {
            var _a = _this.props, onOpen = _a.onOpen, onClose = _a.onClose;
            if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onOpen && onOpen("down");
            }
            else if (e.key === "ArrowUp") {
                e.preventDefault();
                onOpen && onOpen("up");
            }
            else if (e.key === "Escape") {
                onClose && onClose();
            }
        };
        _this.handleOnMouseDown = function (e) {
            e.preventDefault();
        };
        return _this;
    }
    MenuButton.prototype.componentDidUpdate = function (prevProps) {
        var _a;
        var _b = this.props, focusIndex = _b.focusIndex, forceClose = _b.forceClose;
        if (focusIndex !== prevProps.focusIndex &&
            focusIndex === -1 &&
            !forceClose) {
            (_a = this.ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    MenuButton.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, onToggle = _a.onToggle, onOpen = _a.onOpen, onClose = _a.onClose, idRef = _a.idRef, children = _a.children, props = __rest(_a, ["isOpen", "onToggle", "onOpen", "onClose", "idRef", "children"]);
        return (React.createElement(Container, __assign({ ref: this.ref, "aria-haspopup": "true", "aria-controls": idRef, "aria-expanded": isOpen, "aria-label": "Menu Container", onClick: onToggle, onKeyDown: this.handleOnKeyDown, onMouseDown: this.handleOnMouseDown }, props), children));
    };
    return MenuButton;
}(Component));
export default MenuButton;
